<template>
  <div
    v-if="isOpenSelectRole"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm font-poppins p-4"
  >
    <div class="flex items-center min-h-screen justify-center">
      <div
        class="w-full max-w-4xl bg-white rounded-xl shadow-lg overflow-auto max-h-screen"
      >
        <!-- Green Header -->
        <div
          class="bg-[#147452] w-full h-12 rounded-t-xl flex justify-between items-center px-4 text-white"
        >
          <h1 class="text-lg font-medium tracking-wide">Select your account</h1>
          <button
            @click="toggleClose"
            class="p-2 rounded-full hover:bg-green-200 transition-colors cursor-pointer"
          >
            <icon name="close" />
          </button>
        </div>

        <!-- Content -->
        <div class="p-5 space-y-6">
          <!-- Notice Content -->
          <div class="w-full p-2 bg-red-200 rounded-lg flex items-start gap-2">
            <icon
              name="exclamationmark"
              class="text-red-600 animate-pulse mt-1"
            />
            <p class="text-sm text-gray-800">
              It appears you have multiple accounts with different roles or
              designations. To ensure you access the right features, please
              select the appropriate account below.
            </p>
          </div>

          <!-- Role Cards -->
          <div class="flex flex-col md:flex-row md:flex-wrap gap-4">
            <div
              class="bg-white shadow w-full md:w-[calc(50%-0.5rem)] h-auto p-4 border hover:border-green-900 rounded-lg cursor-pointer hover:shadow-xl transition duration-200 ease-in-out"
              v-for="(cred, index) in credentials"
              :key="index"
              :value="cred.id"
              @click="goToSystem(cred.email, cred.password)"
            >
              <p
                class="px-3 w-fit h-7 mb-2 bg-green-300 text-gray-800 rounded-full flex justify-center items-center text-[14px] font-bold"
              >
                {{
                  index === 0
                    ? `First Account`
                    : index === 1
                    ? `Second Account `
                    : `No Account `
                }}
              </p>
              <div class="p-2 space-y-2 text-sm md:text-base">
                <p>
                  <span class="font-semibold">Email:</span> {{ cred.email }}
                </p>
                <p>
                  <span class="font-semibold">Role:</span>
                  {{ cred.designation ? cred.designation : cred.role }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon from "../icon.vue";
export default {
  name: "RolesPage",
  components: {
    icon,
  },
  props: {
    data: {},
  },
  data() {
    return {
      credentials: [],
      system_data: {},
      isOpenSelectRole: true,
    };
  },
  mounted() {
    console.log("Info Data", this.data);
    this.system_data = this.data.system_data;
    this.credentials = this.data.credentials;
    console.log("Users", this.$store.state.user);
  },
  methods: {
    toggleClose() {
      this.isOpenSelectRole = false;
      this.$emit("close");
    },
    goToSystem(email, password) {
      // window.open(
      //   this.system_data.url + "?email=" + email + "&pass=" + password,
      //   "_blank"
      // );
      let data = new FormData();
      data.append("email", email);
      data.append("password", password);
      this.axiosCall2(this.system_data.login_api, "POST", data).then((res) => {
        console.log(res.data);
        if (res.data) {
          const token = this.findPropertyValue(res.data, "token");
          if (token) {
            window.open(this.system_data.url + "?token=" + token, "_blank");
          }
        }
      });
    },
  },
};
</script>
<style></style>
